// extracted by mini-css-extract-plugin
module.exports = {"group":"index-module--group--3yD_g","content":"index-module--content--2x3Sa","contentCollapsed":"index-module--content-collapsed--29gtF","inline":"index-module--inline--2c3fL"};